export const ApplicationPaths = {
  HomePath: '/home',
  CatalogPath: '/catalog',
  InventoryPath: '/inventory',
  UsersPath: '/users',
  StorePath: '/store'
};

export const DEMO_PLAYER_USERNAME = 'demo@player.com';
